import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  effect,
  HostListener,
  inject,
  OnChanges,
  OnInit,
  Renderer2,
  signal,
  SimpleChanges,
  TemplateRef,
  WritableSignal
} from '@angular/core';
import {RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {SecurityService} from "../../../security/security.service";
import {CommonModule} from "@angular/common";
import {FeatherModule} from "angular-feather";
import {SharedCommonModule} from "../../../shared/commons/shared-common.module";
import {LoadingComponent} from "../../../shared/commons/loader/loading.component";
import {notImplementedYet} from "../../../app.constants";
import {FormsModule} from "@angular/forms";
import {UserData} from "../../../../generated-model/model";
import {environment} from "../../../../environments/environment";
import {NgbOffcanvas, OffcanvasDismissReasons} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    RouterOutlet,
    FeatherModule,
    RouterLinkActive,
    SharedCommonModule,
    LoadingComponent
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent implements OnInit, AfterViewInit, AfterViewChecked, OnChanges {
  environment = environment
  principal?: (UserData & { name?: string });
  authenService = inject(SecurityService);
  renderer = inject(Renderer2);
  protected readonly notImplementedYet = notImplementedYet;
  selectedFontSize: '14px' | '16px' | '18px' = '14px';
  toggleOffCanvas = false;
  isSidebarCollapsed = false;
  private offcanvasService = inject(NgbOffcanvas);
  closeResult: WritableSignal<string> = signal('');
  // isTestEnv = signal(!isDevMode() && environment.production === false);
  isTestEnv = signal(environment.test);

  constructor() {
    effect(() => {
      this.calculateLayoutRatio();
    });
  }

  ngOnInit(): void {
    this.toggleOffCanvas = window.innerWidth < 992;
    this.isSidebarCollapsed = window.innerWidth < 992;

    this.authenService.user$()
      .subscribe((value: any) => {
        this.principal = value;
      });
  }

  ngAfterViewInit(): void {
    this.calculateLayoutRatio();
  }

  ngAfterViewChecked(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes)
  }

  openSidebarOffcanvas(content: TemplateRef<any>) {
    this.offcanvasService.open(content, {ariaLabelledBy: 'offcanvas-basic-title'}).result.then(
      (result) => {
        this.closeResult.set(`Closed with: ${result}`);
      },
      (reason) => {
        this.closeResult.set(`Dismissed ${this.getDismissReason(reason)}`);
      },
    );
  }

  private getDismissReason(reason: any): string {
    switch (reason) {
      case OffcanvasDismissReasons.ESC:
        return 'by pressing ESC';
      case OffcanvasDismissReasons.BACKDROP_CLICK:
        return 'by clicking on the backdrop';
      default:
        return `with: ${reason}`;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    // 1024px is break point of large devices
    console.log('window:resize');
    this.calculateLayoutRatio();
    // 992px is break point of large devices
    this.toggleOffCanvas = event.target.innerWidth < 992;
    this.isSidebarCollapsed = event.target.innerWidth < 992;
  }

  calculateLayoutRatio() {
    // let sidebar = document.getElementById("sidebar");
    // let content = document.getElementById("content");
    // if (this.toggleSidebar()) {
    //   content.style.width = `calc(100% - 300px);`;
    // } else {
    //   content.style.width = '100%;'
    // }
  }

  logout() {
    this.authenService.logout();
    // this.http.post(`${environment.serverUrl}/logout`, {})
    //   .subscribe();
  }

  setFontSizeTo(fontSize: string) {
    this.renderer.setAttribute(document.querySelector('body'), 'data-default-font-size', fontSize);
  }

  profile() {
    window.location.href = `${environment.profileUrl}?referrer=${environment.clientId}`;
  }

  protected readonly open = open;
}
